import { CaretUpOutlined, CaretDownOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, InputRef, List, Row, Tooltip } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import React, { useRef, useState, useEffect } from 'react';
import style from './Tables.module.scss'
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { useHistory } from "react-router-dom";
import { RegisterUser, Rol, UserState } from '../../../store/user/types';
import moment from 'moment';
import {
    getAllEstablishmentTable, postResgisterEstablishment, putResgisterEstablishment,
    getEstablishmentByCode, putActiveEstablishment, deleteEstablishmentById, getAllEstablishmentTableByUser,

    deleteEstablishmentMethodById,
    getAllEstablishmentTableByOrganization
} from '../../../store/establishment/thunks';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validateNumber, validateYear4, validate125, validate150, validate255 } from '../../../globals/Inputs/validateInput';
import validateMessages from '../../../globals/Inputs/validateMessages';
import { typesIdentification } from '../../../globals/Parameters/listParameters';
import TextArea from 'antd/es/input/TextArea';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Cities, Organization } from '../../../store/organization/types';
import { openNotification } from '../../../globals/Components/Notification/Notificaction';
import { getAllGeiInventoryFilter, getGeiInventoryById } from '../../../store/geiInventory/thunks';
import { GeiInventory } from '../../../store/geiInventory/types';
import { Establishment } from '../../../store/establishment/type';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { getUserByToken } from '../../../store/user/thunks';
import { useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import {
    InfoCircleOutlined
} from '@ant-design/icons';
import { Card } from 'antd';
import { getAllCitiesByOrganization, getOrganizationById } from 'src/store/organization/thunks';

interface UserTableProps {
    getAllEstablishmentTable?: any;
    postResgisterEstablishment?: any;
    putResgisterEstablishment?: any;
    getEstablishmentByCode?: any;
    putActiveEstablishment?: any;
    deleteEstablishmentById?: any;
    getAllGeiInventoryFilter?: any;
    user: UserState;
    getUserByToken?: any;
    getAllEstablishmentTableByUser?: any;
    getAllEstablishmentTableByOrganization?: any;
    getGeiInventoryById?: any;
    deleteEstablishmentMethodById?: any;
    getOrganizationById?: any;
    getAllCitiesByOrganization?: any;

}

interface DataType {
    key: string;
    id: string;
    organization: string;
    openingYear: number;
    code: string;
    name: string;
    type: string;
    msCatalogueCityId: string;
    address: string;
    status: string;
    created_at: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TEstablishment: React.FC<UserTableProps> = (props: UserTableProps) => {
    interface RouteParams {
        idOrganization: string;
    }
    const params = useParams<RouteParams>();
    const dateFormat = 'YYYY-MM-DD';
    const history = useHistory();
    const [form] = Form.useForm();
    const [formValidate] = Form.useForm();
    const [dataTable, setDataTable] = useState<DataType[]>([]);
    const [searchText, setSearchText] = useState('');
    const [cities, setCities] = useState([]);
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalValidateUser, setIsModalValidateUse] = useState(false);
    const [isModalValidateInactiveUser, setIsModalValidateInactiveUser] = useState(false);
    const [typeModal, setTypeModal] = useState(true);
    const [selectedRolId, setSelectedRolId] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const { Option } = Select;
    const [type, setType] = useState("");
    const [userData, setUserData] = useState<DataType>();
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [typeActive, setTypeActive] = useState(false);
    const [gei, setGei] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [data, setData] = useState([]);
    const [dataIdentification, setDataIdentification] = useState('N/A');
    const [dataName, setDataName] = useState('N/A');
    const [pagasize, setPageSize] = useState(5);

    const [searchValue, setSearchValue] = useState('');
    const [options, setOptions] = useState([]);
    const [dataFilter, setDataFilter] = useState([]);

    const handleSearchFilter = async (value: string) => {

        setSearchValue(value);
        if (value) {
            const responseData = await props.getAllGeiInventoryFilter(value);
            setDataFilter(responseData);
        } else {
            setDataFilter([]);
        }
    };

    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: pagasize,
    });
    const handleExportToExcel = () => {
        const exportData = dataTable.map(item => ({
            'Código': item.code,
            'Año de apertura': item.openingYear,
            'Nombre': item.name,
            'Formato': item.type,
            'Ciudad': item.msCatalogueCityId,
            'Dirección': item.address,
            'Estado': item.status,
            'Creado': item.created_at,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Instalaciones');

        const excelFileName = 'Instalaciones.xlsx';
        XLSX.writeFile(wb, excelFileName);

        openNotification("Exportación exitosa", `Los datos se han exportado a ${excelFileName}`);
    };

    const handleTableChange = async (pagination: TablePaginationConfig) => {
        setPagination({ ...pagination });
            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);
            setDataTable(responseData.establishmentTable);
        
    };

    const init = async () => {
        const organization: Organization = await props.getOrganizationById(params.idOrganization);
        setDataIdentification(organization.ruc)
        setDataName(organization.name)
        
        const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);

        if (responseData != undefined) {
            setPagination({
                current: 1,
                pageSize: pagasize,
                total: responseData.totalTable
            })
            setDataTable(responseData.establishmentTable);
        }

    }
    useEffect(() => {
        init();
    }, []);




    const handleSearch = async (
        selectedKeys: string[],
    ) => {

        if (props.user.rol == "administrator" || props.user.rol == "super_admin") {
            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, selectedKeys.length > 0 ? selectedKeys[0] : "NULL", isSort);
            setDataTable(responseData.establishmentTable);
        }
        else if (props.user.rol == "client") {
            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, selectedKeys.length > 0 ? selectedKeys[0] : "NULL", isSort);
            setDataTable(responseData.establishmentTable);
        }

    };

    const handleReset = async (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
        if (props.user.rol == "administrator" || props.user.rol == "super_admin") {
            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);
            setDataTable(responseData.establishmentTable);
        }
        else if (props.user.rol == "client") {
            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);
            setDataTable(responseData.establishmentTable);

        }
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[])}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[])}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    const [isSort, setIsSort] = useState('NULL');
    const [isSortValue, setIsSortValue] = useState('desc');
    const insertSortResponse = async () => {

        if (isSortValue == "asc") {
            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", "asc");
            setDataTable(responseData.establishmentTable);
            setIsSort("asc");
            setIsSortValue("desc")
        } else {

            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", "desc");
            setDataTable(responseData.establishmentTable);
            setIsSort("desc");
            setIsSortValue("asc")
        }

    }




    const columns: ColumnsType<DataType> = [
        {
            title: '',
            dataIndex: 'id',
            width: 0,
            key: 'id',
            render: () => null,

        },
        {
            title: '',
            width: 0,
            dataIndex: 'msCatalogueCityId',
            key: 'msCatalogueCityId',
            render: () => null,

        },
        {
            title: 'Código',
            width: 25,
            dataIndex: 'code',
            key: 'code',
            ...getColumnSearchProps('code', 'código'),
        },

        {
            title: (
                <div>
                    {/* <CaretUpOutlined /> Icono de calendario */}
                    Año de apertura
                    <span onClick={insertSortResponse} style={{ marginLeft: 10, cursor: "pointer" }}> {isSortValue == "desc" ? <CaretDownOutlined /> : <CaretUpOutlined />}</span>
                </div>
            ),
            width: 35,
            dataIndex: 'openingYear',
            key: 'openingYear',
            defaultSortOrder: 'descend',

            //sorter: compareAge

            //     const dateA = new Date(a.opening_year);
            //     const dateB = new Date(b.opening_year);

            //     return dateA.getTime() - dateB.getTime();
            // },
        },

        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            width: 50,
        },
        {
            title: 'Formato',
            dataIndex: 'type',
            key: 'type',
            width: 25,
            //...getColumnSearchProps('organization', 'Organizacion'),
        },
        {
            title: 'Ciudad',
            dataIndex: 'msCatalogueCityName',
            key: 'msCatalogueCityName',
            width: 35,
            //...getColumnSearchProps('email', 'correo'),
        },
        {
            title: 'Dirección',
            dataIndex: 'address',
            key: 'address',
            width: 50,
            render: (text, record) => (
                <span style={{ fontSize: '12px', lineHeight: '0.1' }}>{text}</span>
            )
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 20,
            filters: [
                {
                    text: 'Activo',
                    value: 'ACTIVO',
                },
                {
                    text: 'Inactivo',
                    value: 'INACTIVO',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.status.indexOf(value) === 0;
                }
                return false;
            },
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 25,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },


    ];
    const newAction: ColumnType<DataType> = {
        title: '',
        key: 'operation',
        fixed: 'right',
        width: 20,

        render: (record: DataType) =>
            <Space size="middle">
                <Space size="middle">
                    <Tooltip placement="topRight" title={validateMessages.updateButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showModalUpdate(record)}
                            icon={<EditOutlined />}
                        />
                    </Tooltip>

                </Space>
                {record.status == "ACTIVO" &&
                    <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                        <Button
                            type="text"
                            className={style["danger-button"]}
                            onClick={() => deleteUserTable(record)}
                            icon={<DeleteOutlined />}
                        />
                    </Tooltip>

                }
                <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                    <Button
                        type="text"
                        className={style["eliminate-button"]}
                        onClick={() => handleTypeDeleteButton(record.id)}
                        icon={<CloseCircleOutlined />}
                    />
                </Tooltip>


            </Space>,
    };

    const adminColumns: ColumnsType<DataType> = [
        ...columns,
        ...[newAction],
    ];
    const clientColumns: ColumnsType<DataType> = [
        ...columns,
        ...[newAction],
    ];
    const handleOk = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleDeleteOk = async () => {
        setIsModalDeleteOpen(false);
        await props.deleteEstablishmentById(userData?.id);
        const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);
        setDataTable(responseData.establishmentTable);
    };
    const handleValidateUserOk = async () => {
        setIsModalValidateUse(false);
    };

    const handleValidateInactiveUserOk = async () => {

        const registerUser = {
            id: userData?.id,
            geiInventoryId: userData?.id,
            year: "",
            code: "",
            name: "",
            type: "",
            status: "",
            city: "",
            address: ""
        };
        await props.putActiveEstablishment(registerUser);
        const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);
        setDataTable(responseData.establishmentTable);
        setIsModalValidateInactiveUser(false);
        handleCancel();
    };
    const handleDeleteCancel = () => {
        setIsModalDeleteOpen(false);
    };
    const handleValidateUserCancel = () => {
        setIsModalValidateUse(false);
    };
    const handleValidateInactiveUserCancel = () => {
        setIsModalValidateInactiveUser(false);
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const showModalCreate = async () => {
        const responseData = await props.getAllCitiesByOrganization(params.idOrganization)
        setCities(responseData);
        setTypeActive(false);
        setIsFormValidate(true);
        setIsModalOpen(true);
        setTypeModal(true);

    };
    const showModalUpdate = async (value: DataType) => {
        const responseDataCity = await props.getAllCitiesByOrganization(params.idOrganization)
        setCities(responseDataCity);
        if (value.status.trim() == "INACTIVE") {
            setTypeActive(true);
        }
        form.setFieldsValue({
            id: value.id,
            geiInventoryId: value.organization,
            year: value.openingYear,
            code: value.code,
            name: value.name,
            type: value.type,
            city: value.msCatalogueCityId,
            address: value.address
        });

        setUserData({
            key: "1",
            id: value.id,
            organization: value.organization,
            openingYear: value.openingYear,
            code: value.code,
            name: value.name,
            type: value.type,
            msCatalogueCityId: value.msCatalogueCityId,
            address: value.address,
            status: value.status,
            created_at: value.created_at,

        });
        setIsModalOpen(true);
        setIsFormValidate(false);
        setTypeModal(false);
    };

    const deleteUserTable = async (id: DataType) => {
        setUserData(id)
        setIsModalDeleteOpen(true);

    };
    const onFinish = async (values: any) => {
        const register = {
            id: values.id,
            organizationId: params.idOrganization,
            openingYear: values.year,
            code: values.code,
            name: values.name,
            type: values.type,
            msCatalogueCityId: values.city,
            address: values.address
        };
        handleCancel();
        if (typeModal) {
            await props.postResgisterEstablishment(register);
        } else {
            await props.putResgisterEstablishment(register);
        }
        const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);
        setDataTable(responseData.establishmentTable);
        form.resetFields();
    };

    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);
    const [isIdData, setIdData] = useState<String>("");
    const handleDeleteMethodOk = async () => {
        const responseData = await props.deleteEstablishmentMethodById(isIdData);
        if (responseData != undefined) {
            const responseData = await props.getAllEstablishmentTableByOrganization(pagination.current, pagination.pageSize, params.idOrganization, "NULL", isSort);
            setDataTable(responseData.establishmentTable);
        }

        setIsModalDeleteMethodOpen(false);
    };
    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButton = async (value: String) => {
        setIdData(value);
        setIsModalDeleteMethodOpen(true);

    }

    return (
        <>
            <Row justify="space-between" align="middle">
                <Col >

                    <Button
                        type="primary"
                        icon={<PlusCircleOutlined />}
                        className={style["create-button-user"]}
                        onClick={showModalCreate}
                    >
                        Crear instalación
                    </Button>

                    <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        style={{ backgroundColor: '#1f71d9', borderColor: 'gray', marginLeft: '8px' }}
                        onClick={handleExportToExcel}
                    >
                        Exportar a Excel
                    </Button>
                </Col>
                <Col>
                    <Card title="Organización: " style={{ width: 750, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <b>Identifiación::  </b>{dataIdentification}  <b> Nombre: </b> {dataName}
                    </Card>
                </Col>
            </Row>

            <Table size="small" columns={adminColumns } dataSource={dataTable} scroll={{ x: 1500 }} pagination={pagination}
                onChange={handleTableChange} />
            <Drawer title={typeModal ? "Crear instalación" : "Actualizar instalación"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    {typeActive ?
                        <Button
                            type="primary"
                            className={style["reset-button-user"]}
                            onClick={handleValidateInactiveUserOk}
                        >
                            Activar establecimiento
                        </Button>
                        : <></>}

                    <Form.Item label="Gei inventario" name="geiInventoryId" hidden={true}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: string) => setSearchValue(type)}
                            optionFilterProp="children"
                            // filterOption={(input: any, option: any) =>
                            //     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            // }
                            onSearch={handleSearchFilter}
                            filterOption={false}
                            value={searchValue}
                            placeholder="Escoga GEI inventario"
                        >
                            {dataFilter.map((type: GeiInventory) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.code + "-" + type.organization + "-" + type.year}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item style={{ display: 'none' }} name="id">
                        <Input />
                    </Form.Item>

                    <Form.Item label="Año de apertura" name="year" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateYear4(value) },
                    ]}>
                        <Input placeholder="Ingresar año" />
                    </Form.Item>

                    <Form.Item label="Ciudad" name="city" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: string) => setType(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={type}
                            placeholder="Escoga la ciudad"
                        >
                            {cities.map((type: Cities) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item tooltip="Debe ser un código único." label="Código" name="code" rules={[{ required: true, message: validateMessages.emptyField },]}>
                        <Input disabled={typeModal ? false : true} placeholder="Ingresar código" />
                    </Form.Item>
                    <Form.Item name="name" label="Nombre" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate125(value) }]}>
                        <Input placeholder="Ingresar nombre" />
                    </Form.Item>

                    <Form.Item name="type" label="Formato" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) }]}>
                        <Input placeholder="Ingresar formato" />
                    </Form.Item>
                    <Form.Item name="address" label="Dirección" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate255(value) }]} >
                        <TextArea placeholder="Ingresar dirección" />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Agregar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>

            </Drawer>
            <Modal open={isModalDeleteOpen} onOk={handleDeleteOk} onCancel={handleDeleteCancel}>
                <h3>¿Esta seguro de inactivar el establecimiento {userData?.name} con código {userData?.code}? </h3>
            </Modal>
            <Modal open={isModalDeleteMethodOpen} onOk={handleDeleteMethodOk} onCancel={handleDeleteMethodCancel}>
                <h3>¿Esta seguro que desea eliminar el Establecimiento? </h3>
            </Modal>
            {/* <Modal open={isModalValidateUser} onOk={handleValidateUserOk}  onCancel={handleValidateUserCancel}>
                <h3>El usuario {userData?.fullname} con cédula {userData?.identification} y {userData?.email} ya se encuentra activo </h3>
            </Modal>
            <Modal open={isModalValidateInactiveUser} onOk={handleValidateInactiveUserOk}  onCancel={handleValidateInactiveUserCancel}>
                <h3>El usuario {userData?.fullname} con cédula {userData?.identification} y {userData?.email} se encuentra inactivo. <br/> ¿Deseas activarlo? </h3>
            </Modal> */}

        </>


    );


};

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps, {
    getAllEstablishmentTable, postResgisterEstablishment, putResgisterEstablishment,
    getEstablishmentByCode, putActiveEstablishment, getUserByToken, deleteEstablishmentById,
    getAllGeiInventoryFilter, getAllEstablishmentTableByUser, getAllEstablishmentTableByOrganization,
    getGeiInventoryById, deleteEstablishmentMethodById, getOrganizationById,
    getAllCitiesByOrganization
})(TEstablishment);